<!--
The rationale for this modal is that the user/practitioner is not authorized to create contact bookings
if they don't have at least "view" access to "all clients".
A contact is essentially a client, but it's not possible to assign a contact to a practitioner yet.
So they will only be able to see a contact when they have access to all clients.
-->
<script>
import Modal from '@/system/components/global/Modal';

export default {
    components: {
        Modal,
    },

    data() {
        return {
            showModal: false,
        };
    },

    mounted() {
        this.registerModalEventListeners();
    },

    methods: {
        registerModalEventListeners() {
            this.$event_bus.$on('showCreateContactBooking', () => {
                this.showModal = true;
            });
        }
    }
};
</script>

<template>
    <modal
        id="create-contact-booking-modal"
        v-model="showModal"
        class="create-contact-booking"
    >
        <template #title>
            <h3 class="panel-title">
                {{ trans('apps.other_payers.contact_bookings.create') }}
            </h3>
        </template>

        {{  trans('calendar.client_booking_validation_error') }}
    </modal>
</template>
